import React from "react";
import Drawer from "./navigation/sidebar";
import Appbar from "./navigation/appbar";
import Footer from "./navigation/footer";
import constData from "./../../utilities/const.json";
import { ToastContainer } from "react-toastify";
const Layout = ({ children }) => {
  const isMobile = window.innerWidth >= 992 ? false : true;

  return (
    <div>

      <ToastContainer />

      <Drawer>
        {/*  */}
        <div
          className="container logged-in"
          style={{
            minHeight: isMobile
              ? `calc(100dvh - ${constData.elementSize.MobileFooter} - ${constData.elementSize.MobileHeader} - ${constData.elementSize.MobileAppbar} - 16px)`
              : `calc(100dvh - ${constData.elementSize.DesktopFooter} - ${constData.elementSize.DesktopHeader} - 16px)`,
            marginTop: isMobile
              ? `calc(${constData.elementSize.MobileHeader})`
              : `calc(${constData.elementSize.DesktopHeader})`,
          }}
        >
          {children}
        </div>
        <Footer />
      </Drawer>

      {isMobile && <Appbar />}
    </div>
  );
};

export default Layout;
